export default "__VITE_ASSET__4acffaa1__"